// Browser-safe catalog of models explicitly offered by the CRM OpenRouter route.
// This is deliberately separate from the gateway's general model catalog: a
// browser value must never become an arbitrary provider model identifier.
export const OPENROUTER_CHAT_MODELS = [
  { id: 'deepseek/deepseek-v4.1-flash', label: 'DeepSeek V4.1 Flash', badge: 'Дёшево' },
  { id: 'google/gemini-3.5-flash-lite', label: 'Gemini 3.5 Flash Lite', badge: 'Быстро' },
  { id: 'openai/gpt-5.6-terra', label: 'GPT-5.6 Terra', badge: 'Баланс' },
  { id: '~deepseek/deepseek-v4-flash-latest', label: 'DeepSeek V4 Flash', badge: 'Дёшево' },
  { id: 'minimax/minimax-m3', label: 'MiniMax M3', badge: 'Дёшево' },
  { id: 'openai/gpt-5.4-mini', label: 'GPT-5.4 Mini', badge: 'Качество' },
] as const;

export type OpenRouterChatModelId = (typeof OPENROUTER_CHAT_MODELS)[number]['id'];

export const DEFAULT_OPENROUTER_CHAT_MODEL: OpenRouterChatModelId = 'deepseek/deepseek-v4.1-flash';

export function isOpenRouterChatModel(value: unknown): value is OpenRouterChatModelId {
  return typeof value === 'string' && OPENROUTER_CHAT_MODELS.some((model) => model.id === value);
}
